import { Icon } from '@scale/scaleui';
import { useCurrentEditor } from '@tiptap/react';
import useIsEditorEditable from '../../hooks/useIsEditorEditable';

export function CodeBlockButton() {
  const { editor } = useCurrentEditor();
  const isEditable = useIsEditorEditable();
  if (!editor) return null;
  return (
    <div className="p-2">
      <Icon
        tooltip="Code Block"
        tooltipProps={{
          delayDuration: 0,
        }}
        onClick={() => editor.chain().focus().toggleCodeBlock().run()}
        icon="code"
        size="sm"
        selected={editor.isActive('codeBlock')}
        disabled={!isEditable}
      />
    </div>
  );
}
